export { default, type TabsProps, type TabsComponentProps } from './Tabs';
export { default as TabVisibleContext } from './TabVisibleContext';
